import http from 'hub-http/clients/apiClient';
import { CTAS_URL, MIGRATION_URL, PLACEMENTS_URL } from '../constants/LegacyCtas';
export const fetchLastCreatedCta = () => http.get(`/${PLACEMENTS_URL}`, {
  query: {
    offset: 0,
    limit: 1,
    order: '-created_at'
  },
  timeout: 60000
}).then(({
  results
}) => results.length ? results[0] : null);
export const fetchDefaultCta = guid => http.get(`/${CTAS_URL}/ctas`, {
  query: {
    placement_guid: guid
  }
}).then(response => response.results[0]);
export const fetchCtaPlacement = guid => http.get(`/${PLACEMENTS_URL}/${guid}`, {
  timeout: 60000
});
export const fetchCtaDependencies = guid => http.get(`/${PLACEMENTS_URL}/dependencies`, {
  query: {
    placementGuid: guid
  }
}).then(response => Object.assign({}, response, {
  dependencyCount: response.contents.length + response.workflows.length + response.lists.length
}));
export const getMigrationStatus = guid => http.get(`/${MIGRATION_URL}/${guid}/status`);
export const getMigrationHistory = guid => http.get(`/${MIGRATION_URL}/${guid}/history`);
export const retryCtaMigration = (placementGuid, webInteractiveContentId, webInteractiveCrmId, query, ctaGuid) => http.post(`/${MIGRATION_URL}/${placementGuid}/retry-migration`, {
  query: {
    ctaGuid
  },
  data: Object.assign({
    ctaGuid,
    webInteractiveContentId,
    webInteractiveCrmId
  }, query)
});
export const startCtaMigration = (placementGuid, webInteractiveContentId, webInteractiveCrmId, query, ctaGuid) => http.post(`/${MIGRATION_URL}/${placementGuid}/migrate`, {
  data: Object.assign({
    ctaGuid,
    webInteractiveContentId,
    webInteractiveCrmId
  }, query)
});
export const validateCtaMigration = (placementGuid, webInteractiveContentId) => http.get(`/${MIGRATION_URL}/${placementGuid}/can-migrate-to`, {
  query: {
    webInteractiveContentId
  }
});